import type { Card } from '../../types';

/** §14 worked card (ADR-0015 §17 mapping). Pay 3 HP, then deal the summed faces
 * of 3 fresh dice to the enemy. */
export const BLOODLETTING: Card = {
  id: 'bloodletting',
  name: 'Bloodletting',
  type: 'recursive',
  rarity: 'epic',
  size: { w: 2, h: 2 },
  cost: [{ kind: 'exact', value: 6 }],
  effects: [
    { kind: 'damage', amount: 3, target: 'self' },
    {
      kind: 'rollFresh',
      count: 3,
      onSum: [{ kind: 'damage', amount: 0, amountFrom: 'faceSum', target: 'opponent' }],
    },
  ],
};
